/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const HandshakeHeartIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7143 9.07145L11.8525 10.9332C11.2096 11.5759 10.3377 11.937 9.42855 11.937C8.51941 11.937 7.6475 11.5759 7.00455 10.9332L6.85712 10.7857L11.082 6.56088C12.2187 5.42443 13.7603 4.78601 15.3677 4.78601C16.9751 4.78601 18.5167 5.42443 19.6534 6.56088C20.608 7.51557 21.2167 8.76154 21.383 10.1013C21.5493 11.4411 21.2636 12.7981 20.5714 13.9572"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M14.7994 11.8709L17.8963 14.9678C18.3784 15.45 18.6492 16.1039 18.6492 16.7858C18.6492 17.4676 18.3784 18.1216 17.8963 18.6038L16.494 20.0061C16.0164 20.4837 15.4495 20.8626 14.8254 21.1211C14.2014 21.3796 13.5326 21.5127 12.8572 21.5127C12.1817 21.5127 11.5129 21.3796 10.8889 21.1211C10.2649 20.8626 9.69787 20.4837 9.2203 20.0061L4.34659 15.1323C3.21014 13.9956 2.57172 12.454 2.57172 10.8466C2.57172 9.23923 3.21014 7.69766 4.34659 6.56091C5.46708 5.43729 6.98468 4.79964 8.57144 4.78577"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M17.478 19.022L14.1429 15.6877"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
      />
      <path
        d="M15.0111 21.0415L11.8997 17.9301"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
